import {
  chatApi,
  ChatConversation,
  ChatMessage,
  ContainmentOutcome,
  SupportType,
} from "@b2bportal/chat-api";
import {
  ChatTransfer,
  EncodeGenericConversationRequest,
  EncodeGenericConversationResponseEnum,
  ivrApi,
} from "@b2bportal/ivr-api";
import { axiosInstance, trackEvent } from "@hopper-b2b/api";
import { NETWORK_CALL_FAILED } from "@hopper-b2b/types";

export const createChatbotConversation = async (
  supportType?: SupportType
): Promise<ChatConversation> => {
  try {
    const res = await axiosInstance.put("/api/v0/chatbot/create", {
      supportType,
    });
    return res.data.conversation;
  } catch (e) {
    trackEvent({
      eventName: NETWORK_CALL_FAILED,
      properties: {
        url: window.location.pathname,
      },
    });
    throw e;
  }
};

export const sendChatbotMessage = async (
  conversationId: string,
  message: string,
  supportType?: SupportType
): Promise<ChatMessage> => {
  try {
    const res = await axiosInstance.put("/api/v0/chatbot/sendMessage", {
      conversationId,
      message,
      supportType,
    });
    return res.data.message;
  } catch (e) {
    trackEvent({
      eventName: NETWORK_CALL_FAILED,
      properties: {
        url: window.location.pathname,
      },
    });
    throw e;
  }
};

export const getGenericSupportId = async (
  chatTransfer?: ChatTransfer,
  locale?: string,
  funnelType?: string,
  requestType?: string
) => {
  const body: EncodeGenericConversationRequest = {
    chatTransfer,
    funnelType,
    locale,
    requestType,
  };

  try {
    const res = await ivrApi(axiosInstance).apiV0IvrEncodeGenericPost(body);

    if (
      res.data.EncodeGenericConversationResponse ===
      EncodeGenericConversationResponseEnum.Success
    ) {
      return res.data.encodedCode;
    }

    throw res.data;
  } catch {
    trackEvent({
      eventName: NETWORK_CALL_FAILED,
      properties: {
        url: window.location.pathname,
      },
    });
  }
};

export const closeChatbotConversation = async (
  conversationId: string,
  csatScore?: number,
  csatComment?: string,
  issueResolved = false
) => {
  try {
    await chatApi(axiosInstance).apiV0ChatbotClosePut({
      conversationId,
      csatComment,
      csatScore,
      containmentOutcome: issueResolved
        ? ContainmentOutcome.Resolved
        : ContainmentOutcome.Unresolved,
    });
  } catch (err) {
    console.error(err);
    trackEvent({
      eventName: "NETWORK_CALL_FAILED",
      properties: {
        url: window.location.pathname,
      },
    });
  }
};
